import { useQuery } from '@tanstack/react-query';
import {
  fetchBoletinsPorStatusByContratoIds,
  fetchBoletinsPorStatusByContrato,
  type BoletimStatusResumo,
} from '../services/ifDataService';

export type { BoletimStatusResumo };

/** Aggregated for a list of contract IDs (portfolio level) */
export function useIFBoletinsPorStatus(contratoIds: string[]) {
  return useQuery({
    queryKey: ['if-boletins-status', contratoIds],
    queryFn: () => fetchBoletinsPorStatusByContratoIds(contratoIds),
    enabled: contratoIds.length > 0,
    staleTime: 5 * 60 * 1000,
  });
}

/** For a single contract */
export function useIFBoletinsPorStatusContrato(contratoId: string | null) {
  return useQuery({
    queryKey: ['if-boletins-status-contrato', contratoId],
    queryFn: () => fetchBoletinsPorStatusByContrato(contratoId!),
    enabled: !!contratoId,
    staleTime: 5 * 60 * 1000,
  });
}
